import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AboutPage } from './modules/about/AboutPage';
import { ComparePage } from './modules/compare/ComparePage';
import { FoundationsPage } from './modules/foundations/FoundationsPage';
import { HomePage } from './modules/home/HomePage';
import { LeaderboardPage } from './modules/leaderboard/LeaderboardPage';
import { MapDetailPage } from './modules/leaderboard/MapDetailPage';
import { ScanHeroPage } from './modules/scan-hero/ScanHeroPage';
import { ScanPage } from './modules/scan/ScanPage';

const App = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/scan" element={<ScanPage />} />
        <Route path="/scan/:uid" element={<ScanPage />} />
        <Route path="/compare" element={<ComparePage slotCount={2} />} />
        <Route path="/compare/4" element={<ComparePage slotCount={4} />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/leaderboard/map/:challengeUid" element={<MapDetailPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/foundations" element={<FoundationsPage />} />
        <Route path="/hero" element={<ScanHeroPage />} />
        <Route path="/hero/:uid" element={<ScanHeroPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
